
<script>
import {
  isNumeric,
  calcDeltaPrice
} from '@/utils/helpers'
import {
  RexSelect,
  RexInput
} from '@/components/views/rexFieldsV2'
import PopupPenalties from '@/components/views/penalties/PopupPenalties.vue'

export default {
  name: 'medical-insurance-form',
  components: {
    PopupPenalties,
    RexSelect,
    RexInput
  },
  props: {
    formIsShown: {
      type: Boolean,
      default: () => true
    },
    resultIsShown: {
      type: Boolean,
      default: () => false
    },
    insuranceIndex: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    ages: [
      {
        slug: null,
        name: 'Страховка не требуется'
      },
      {
        slug: 0,
        name: 'от 0 до 65 лет'
      },
      {
        slug: 65,
        name: 'от 65 до 80 лет'
      },
      {
        slug: 80,
        name: 'от 80 лет'
      }
    ],
    restType: [
      {
        slug: 1,
        name: 'Да '
      },
      {
        slug: 0,
        name: 'Нет'
      }
    ]
  }),
  computed: {
    getInsurance() {
      return this.$store.getters['cart/getInsurance'](this.insuranceIndex)
    },
    mainServiceIsTours() {
      return this.$store.getters['cart/getMainService'] === 'tours'
    },
    getDates() {
      return this.$store.getters['cart/getDates']
    },
    getInsuranceCollection() {
      const currentInsurancePriceAmount = this.getInsurance.current.price.amount

      return this.getInsurance.collection.map(item => ({
        slug: item.slug,
        name: `${item.name} ${calcDeltaPrice(currentInsurancePriceAmount, item.price.amount)} ${item.price.currency}`
      }))
    },
    numberOfTourists() {
      return this.$store.getters['cart/getNumberOfTourists'].total
    },
    getInsuranceDuration() {
      const {
        startDate,
        endDate
      } = this.getDates

      return `${startDate} - ${endDate}`
    },
  },
  watch: {
    'getInsuranceDuration'() {
      this.setDate(this.getDates)
    },
    'numberOfTourists'() {
      this.setArrayAges()
    }
  },
  created() {
    this.setDate(this.getDates)
    this.setArrayAges()
  },
  methods: {
    search() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$parent.formIsShown = false
          this.$parent.resultIsShown = true

          this.$store.commit('cart/updateServiceModuleIsLoading', {
            status: true,
            target: `insurances.${this.insuranceIndex}.insurances`
          })

          this.$store.dispatch('cart/getInsurances', {
            insuranceIndex: this.insuranceIndex,
            form: {
              ...this.$store.getters['cart/getInsuranceFormForSearch'](this.insuranceIndex)
            }
          })
        }
      })
    },
    setDate({ startDate, endDate }) {
      this.$store.commit('cart/updateServiceField', {
        target: `insurances.${this.insuranceIndex}.form.startDate`,
        value: startDate
      })
      this.$store.commit('cart/updateServiceField', {
        target: `insurances.${this.insuranceIndex}.form.endDate`,
        value: endDate
      })
    },
    setArrayAges() {
      const currentArrayAges = this.$store.getters['cart/getInsuranceForm'](this.insuranceIndex).ages

      this.$store.commit('cart/updateServiceField', {
        target: `insurances.${this.insuranceIndex}.form.ages`,
        value: Array(this.numberOfTourists).fill(null).map((x, i) => {
          const currentArrayAge = isNumeric(currentArrayAges[i])

          return currentArrayAge ? currentArrayAges[i] : null
        })
      })
    },
    select(insuranceId) {
      this.$store.dispatch('cart/getActualize')

      this.$store.commit('cart/removeServiceFromAllPenalties', {
        service: 'insurances',
        serviceId: this.getInsurance.searchId
      })

      if (insuranceId) {
        const {
          searchId: insuranceSearchId,
          resultId: insuranceResultId
        } = this.$store.getters['cart/getIds'].insurances[this.insuranceIndex]
        this.$store.dispatch('cart/getServicePenaltiesForAll', {
          ids: {
            insuranceSearchId,
            insuranceResultId,
            currency: this.$store.getters['cart/getCartPrice'].currency
          },
          serviceName: 'insurances',
          serviceId: this.getInsurance.searchId,
          apiModuleName: 'insurances',
          label: 'Медицинская страховка'
        })
      }
    }
  }
}
</script>

<template>
  <div class="cart__insurance--tourist cart__insurance-tourist">
    <div class="cart__insurance-tourist--form cart__insurance-tourist-form">
      <div
        :class="{ 'full-width': resultIsShown }"
        class="cart__insurance-tourist-form--content"
      >
        <div
          v-for="(i, index) in numberOfTourists"
          :key="index"
          class="cart__search-form-insurances-row"
        >
          <h3 class="cart__search-form-tourist-label">
            Турист {{ index + 1 }}
          </h3>
          <div
            class="cart__search-form-insurances"
            :class="{
              'cart__search-form-insurances--form': formIsShown
            }"
          >
            <rex-input
              label="Дата"
              :name="`insurances_${insuranceIndex}_fromRenderDate`"
              store-module="cart"
              getter-name="getServiceField"
              setter-name="updateServiceField"
              :target="`insurances.${insuranceIndex}.fromRender.date`"
              :is-disabled="true"
              :value="getInsuranceDuration"
            />
            <rex-select
              v-if="!mainServiceIsTours"
              label="Возраст"
              :name="`insurances_${insuranceIndex}_formAges`"
              store-module="cart"
              getter="getServiceField"
              setter="updateServiceField"
              :target="`insurances.${insuranceIndex}.form.ages`"
              :options="ages"
              :validate="{
                required: true
              }"
              :is-disabled="resultIsShown"
            />
            <rex-select
              v-if="!mainServiceIsTours"
              label="Активный отдых"
              :name="`insurances_${insuranceIndex}_formActive`"
              store-module="cart"
              getter="getServiceField"
              setter="updateServiceField"
              :target="`insurances.${insuranceIndex}.form.isActive`"
              :options="restType"
              :is-disabled="index > 0 || resultIsShown"
            />
            <rex-select
              v-if="resultIsShown"
              label="покрытие"
              :name="`insurances_${insuranceIndex}_coverage`"
              store-module="cart"
              getter="getInsuranceCurrent"
              setter="updateInsuranceCurrent"
              :target="`${insuranceIndex}`"
              :options="getInsuranceCollection"
              :is-disabled="index > 0"
              @change="select($event.event)"
            />
            <div
              v-if="formIsShown && index === 0"
              class="cart__insurance-tourist-form--control"
            >
              <b-button
                class="rex-button2"
                type="is-primary"
                expanded
                @click="search"
              >
                Найти
              </b-button>
            </div>
            <div class="cart__penalties">
              <popup-penalties
                v-if="resultIsShown && index === 0"
                :ids="{
                  insuranceSearchId: getInsurance.searchId,
                  insuranceResultId: getInsurance.current.slug
                }"
                store-module="cart"
                service-name="insurances"
                :target="`insurances.${insuranceIndex}`"
                api-module-name="insurances"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
